module.exports = __webpack_public_path__ + "img/AstroFrens74.5d4241bc.jpg";